<template>
	<v-app-bar
		app
		class="secondary"
		dark
	>
		<v-container class="pa-0">
			<v-form ref="formBusca" @submit.prevent="buscar">
				<v-row dense>
					<v-col>
						<v-text-field
							id="styled-input"
							class="styled-input"
							v-model="filtro.busca"
							name="search"
							:placeholder="authModule.éVisitante ? 'Serviços...' : 'Irmão, serviço, loja e mais...'"
							type="search"
							append-icon="mdi-magnify"
							clearable
							@click:clear="() => $emit('limpar-busca')"
							@click:append="buscar"
							required
							single-line
							hide-details
							:loading="buscando"
							:disabled="buscando"
						/>
					</v-col>
					<v-col v-if="!authModule.éVisitante" cols="auto">
						<FiltroDeBusca
							v-model="filtro"
							@confirma="buscar"
						/>
					</v-col>
				</v-row>
			</v-form>
		</v-container>
	</v-app-bar>
</template>

<script lang="ts">
export default {
	inheritAttrs: false,
}
</script>

<script setup lang="ts">
import { PropType, ref } from 'vue'
import FiltroDeBusca from './FiltroDeBusca.vue'
import { CamposDoFiltroDeBusca, obterFiltroDefault } from '@/shareds/sharedBusca'
import { authModule } from '@/store'

const props = defineProps({
	buscando: { default: false, type: Boolean },
	filtro: { default: obterFiltroDefault, type: Object as PropType<CamposDoFiltroDeBusca> },
})

const emit = defineEmits<{
	(e: 'buscar', filtro: CamposDoFiltroDeBusca): void
	(e: 'limpar-busca'): void
}>()

const formBusca = ref<HTMLFormElement & {
	validate: () => boolean,
}>()

async function buscar(event?: InputEvent) {
	if (event) event.preventDefault()
	if (!formBusca.value!.validate()) return
	if (document.activeElement) (document.activeElement as HTMLInputElement).blur()
	emit('buscar', props.filtro)
}
</script>
